const CUSTOMER_TYPE_FIELD = "customerType";
export { CUSTOMER_TYPE_FIELD };
